import React from 'react';
import type { VolumeWidgetConfig } from './types';
import { definition } from './index';

interface VolumeWidgetBuilderProps {
  config: Partial<VolumeWidgetConfig>;
  onChange: (config: VolumeWidgetConfig) => void;
}

const VolumeWidgetBuilder: React.FC<VolumeWidgetBuilderProps> = ({ config, onChange }) => {
  const params = definition.dataProvider?.params ?? [];

  return (
    <div className="space-y-4">
      <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
        <strong>{definition.meta.label}</strong>
        <p className="mt-1">{definition.meta.description}</p>
      </div>

      {params.length > 0 && (
        <div className="space-y-3">
          {params.map(param => (
            <div key={param.key}>
              <label className="block text-sm font-medium text-neutral-700 mb-1">
                {param.label}
                {param.unit && <span className="font-normal text-neutral-400 ml-1">({param.unit})</span>}
              </label>
              <input
                type={param.type || 'text'}
                placeholder={param.placeholder || String(param.defaultValue || '')}
                value={(config as unknown as Record<string, string | number | undefined>)[param.key] ?? ''}
                onChange={(e) => {
                  const val = param.type === 'number' && e.target.value
                    ? parseInt(e.target.value, 10)
                    : e.target.value || undefined;
                  onChange({ ...config, [param.key]: val } as VolumeWidgetConfig);
                }}
                className="w-full border border-neutral-300 rounded-lg px-3 py-2 text-sm"
              />
              {param.defaultValue !== '' && (
                <p className="text-xs text-neutral-500 mt-1">
                  Default: {String(param.defaultValue)}{param.unit ? ` ${param.unit}` : ''}
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
        <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
        <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
          <li>Shows daily volume bars with an ADTV overlay</li>
          <li>Headline metrics: latest volume and 3-month ADTV</li>
          <li>Reuses the FMP historical price feed used by Price</li>
          <li>Requires FMP credentials to be configured in Settings</li>
        </ul>
      </div>
    </div>
  );
};

export default VolumeWidgetBuilder;
